export const environment = {
  production: true,
   cloudUrl:"https://us-central1-probe4shape-498910.cloudfunctions.net/api",
      

      domain:'https://apisoiltest.ikaart.in/',
    Admin:{
    
        GetUserFilterBTYB:"",

        GetOrderMaster:'',
        PostAdminLoginBTYB:'',
        GetUserPostCommentsData:'',
        GetUserProductReviewData:'',
        UpdatePayOuttoStripeAccount:"",
        CreateUpdateUserPostCommentsData:'',
      // Btyb end

      //tattoo admin start
      PostAdminLoginTattoo:'api/Login/LoginAdmin',
      GetTattoArtistAdminData: 'api/Tatto/GetTattoArtistAdminData',
      CreateUpdateVideoMasterData:'api/Tatto/CreateUpdateVideoMasterData',
      GetVideoMasterData:'api/Tatto/GetVideoMasterData',

       //tattoo admin end

       //buysell
       CreateUpdateCategoryMasterData:'api/BuySell/CreateUpdateCategoryMasterData',
       CreateUpdateSubCategoryMasterData:'api/BuySell/CreateUpdateSubCategoryMasterData',  
       GetCategoryMasterData:'api/BuySell/GetCategoryMasterData',
       GetSubCategoryMasterData:'api/BuySell/GetSubCategoryMasterData',
       GetUserFilterBuysell:"",
       GetAdminData:'api/BuySell/GetAdminData',
     
       GetGarageMasterData:'api/BuySell/GetGarageMasterData',
       GetSubsribptionData:'api/BuySell/GetSubsribptionData',
       CreateUpdateUserSubscriptionData:'api/BuySell/CreateUpdateUserSubscriptionData',
       _getUserSubscriptionDetails:'',
       _createUpdateSubscription:'',
       CreateUpdateBrandMasterData:'api/BuySell/CreateUpdateBrandMasterData',
       GetBrandMasterData:'api/BuySell/GetBrandMasterData',

      //1)Login
      PostAdminLogin:"",
      UserForgotPassword:"",
      UserChangePassword:"",
      PostAdminUser:"",
      GetAdminProfileUser:"",

      //2)App User
      GetUserFilter:"",
      PostUser:"",
      //product-deetails
      AddUserAdminDetails:"",
         GetUserAdminDetails:"",
         GetUserAdminRoleDetails:"api/SoilShapeApi/GetUserAdminRole",
         getMenuRoleRelation:"api/SoilShapeApi/GetMenuRoleRelation",
         getMenu:"api/SoilShapeApi/GetMenuMaster",
         GetUsers:'api/DatingApi/GetUserMasterData',
         GetUserPost:'api/DatingApi/GetUserPost',
         DeleteUserMaster1:'api/DatingApi/DeleteUserMaster',
         CreateUpdateUserPost:'api/DatingApi/CreateUpdateUserPost',
      
         GetUserPostData:'api/SoilShapeApi/GetUserPostData',
         GetUserMasterData1:"api/SoilShapeApi/GetUserMasterData",
         CreateUpdateUserBlock:"api/SoilShapeApi/CreateUpdateUserBlock",
         CreateUpdatePostBlock:"api/SoilShapeApi/CreateUpdatePostBlock",
         CreateUpdateUserFlagRel:"api/SoilShapeApi/CreateUpdateUserFlagRel",
         GetPostBlock:"api/SoilShapeApi/GetPostBlock",
         GetUserFlagRel:"api/SoilShapeApi/GetUserFlagRel",
         GetUserBlock:"api/SoilShapeApi/GetUserBlock",
         CreateUpdateQuestionMaster:'api/SoilShapeApi/CreateUpdateQuestionMaster',
         GetQuestionMaster:'api/SoilShapeApi/GetQuestionMaster',
         CreateUpdateQuestChild:'api/SoilShapeApi/CreateUpdateQuestChild',
         GetUserAnswersENC:"api/SoilShapeApi/GetUserAnswersENC",
         Login:"api/Login/Login",
         GetUserMasterData:"api/SoilShapeApi/GetUserMasterData",
         DeleteUserMaster:'api/SoilShapeApi/DeleteUserMaster',
         AddUserMasterData:"api/SoilShapeApi/AddUserMasterData",
         GetQuestionTypeMaster:"api/SoilShapeApi/GetQuestionTypeMaster",
         GetQuestionCategoryMaster:'api/SoilShapeApi/GetQuestionCategoryMaster',
         exportexcel:"api/Export/export-excel",
         AdminData:"api/Export/AdminData",
            // GetUserAnswersENC:"api/Export/GetUserAnswersENC",
         Admin_Data:"api/SoilShapeApi/Admin_Data",

     GetUserAdminMaster:"api/SoilShapeApi/GetUserAdminMaster",
      CreateUpdateUserAdminMaster:"api/SoilShapeApi/CreateUpdateUserAdminMaster",
      
         AddCollectionMaster:"",
         GetCollectionMaster:"",
         GetUserFollwers:"",
         AddUserCollection:"",
         GetUserCollection:"",
    
         AddUserPost:"",
        //  GetSpotlightPost:"api/Fashion/",
        //  AddSpotlightPost:"api/Fashion/",
        GetDropDownCollection:"",
        ImageProductDetails:"",
        DropDownDetails:"",
    },
   
    aws3ApiKey:{
      keyPrefix: "aageskitchen/",
      bucketName:'aageskitchen',
      //dirName:'',
      region:'us-east-2',
      accessKeyId:'AKIAWNHTHLLSQFXIRQU4',
      secretAccessKey:'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',
      s3Url:'https://aageskitchen.s3.us-west-2.amazonaws.com/'
      
    },
  
};
